





































import Vue, { PropOptions } from 'vue';
import { VueEditor } from 'vue2-editor';
import ProductSalesPageUploader from '@/web/components/products/sales-page/ProductSalesPageUploader.vue';

interface ProductSolutionProps {
  value: PropOptions;
}

export default Vue.extend({
  name: 'ProductSalesPageSolution',
  components: { VueEditor, ProductSalesPageUploader },
  props: {
    value: {
      type: Object as () => ProductSalesPageSolutionResponse,
    },
  } as ProductSolutionProps,
  methods: {
    handleOnInput(key: string, value: any): void {
      const emitData = {
        ...this.value,
        [key]: value,
      };
      this.$emit('input', emitData);
    },
  },
});
